jQuery(document).ready(function($) {
  var hasTargetPartNumber = false;
  var partNumberPairs = [
    { targetPartNumber: '525300-001', affectedPartNumbers: ['529346-001', '529805-001'] },
    { targetPartNumber: '525301-005', affectedPartNumbers: ['529346-001', '529805-001'] },
    { targetPartNumber: '525301-001', affectedPartNumbers: ['529346-001', '529805-001'] },
    { targetPartNumber: '651577', affectedPartNumbers: ['659945'] },
    { targetPartNumber: '653636', affectedPartNumbers: ['653635', '653538', '653543', '653539', '653540'] },
    { targetPartNumber: '653637', affectedPartNumbers: ['653635', '653538', '653543', '653539', '653540'] },
    { targetPartNumber: 'B22U0000RS', affectedPartNumbers: ['EWBD212SD', 'EWBD224SD'] },
    // Add more pairs as needed
  ];

  var foundTargets = {};

  // Iterate over each cart item to check for the target part number
  $('.cart-item').each(function() {
    var cartItem = $(this);
    var partNumber = cartItem.find('.part-number > strong').text().trim();

    partNumberPairs.forEach(function(pair) {
      if (partNumber === pair.targetPartNumber) {
        foundTargets[pair.targetPartNumber] = true;
      }
    });
  });
  
  // If any target part number is found, hide remove/input from the affected items
  $('.cart-item').each(function() {
    var cartItem = $(this);
    var partNumber = cartItem.find('.part-number > strong').text().trim();

    partNumberPairs.forEach(function(pair) {
      if (foundTargets[pair.targetPartNumber] && pair.affectedPartNumbers.includes(partNumber)) {
        // Hide the remove button and input field
        cartItem.find('.cart-item__quantity-wrapper').hide();
      }
    });
  });

  $("cart-remove-button a.button").click(function() {
    var cartItem = $(this).parent().parent().parent().parent();
    var partNumber = cartItem.find('.part-number > strong').text().trim();
    console.log(partNumber);

    partNumberPairs.forEach(function(pair) {
      if (foundTargets[pair.targetPartNumber]) {
        $('.cart-item').each(function() {
          var cartItemNew = $(this);
          var partNumberNew = cartItemNew.find('.part-number > strong').text().trim();
          if (pair.affectedPartNumbers.includes(partNumberNew)) {
            cartItemNew.find('cart-remove-button a.button').click();
          }
        });
      }
    });
  });
});